/* eslint-disable no-console */
import Constants from './modules/awning-configurator/utils/constants';
import { addToEpiCart } from './utils/cart-utils';
import {
  getActiveSeriesBtn,
  updateSeriesButtonLabels,
  updateSeriesHeading,
  updateSeriesWrapper,
} from './modules/awning-configurator/steps/series';
import {
  addAwningToGtmDataLayer,
  addAwningToSstParamList,
  getAwningItemNumber,
  resetInputs,
} from './modules/awning-configurator/utils/cart-utils';
import {
  getCollectionNameFromHash,
  getSelectedCollection,
  getSelectedFabricOptions,
  initializeFabricDataAttributes,
  updateCollectionsBySeries,
  updateSelectedCollection,
} from './modules/awning-configurator/steps/fabric';
import {
  getModelDataByCode,
  hideAllModels,
  // showFirstModel,
  showModelByName,
  updateModelButtonLabels,
  updateModelsBySeries,
} from './modules/awning-configurator/steps/model';
import {
  isStepHidden,
  resetStepSelections,
  scrollToSection,
  toggleStepAvailability,
  toggleStepByName,
  toggleStepTitleByName,
  updateAvailableStepNums,
  isProUpgradable,
  isProModel,
  hasLed,
} from './modules/awning-configurator/utils/configuration-utils';
import {
  saveToSession,
} from './utils/session-storage-utils';
import {
  resetMountUI,
  updateAluminumHoodPrice,
  updateAluminumHoodUI,
  updateMountUI,
  updateSoffitBracketPrice,
} from './modules/awning-configurator/steps/mount';
import { updateFrameColorUI } from './modules/awning-configurator/steps/frame-color';
import {
  updateProjectionUI,
  updateProjectionUpgradeOptions,
} from './modules/awning-configurator/steps/projection';
import { validate } from './modules/awning-configurator/utils/validation-utils';

export default class AwningConfigurator {
  constructor() {
    this.state = {
      aluminumHood: '',
      aluminumHoodUpgrade: '',
      active: {
        element: '',
        option: '',
      },
      cordSide: '',
      fabric: '',
      fabricCode: '',
      fabricCollection: '',
      frameColor: '',
      hasFrameColorOpt: true,
      itemNumber: '',
      isCostco: false,
      masonryKit: '',
      model: '',
      modelCode: '',
      mount: '',
      price: {},
      scrollToModels: false,
      projection: '',
      projectionUpgrade1: '',
      projectionUpgrade2: '',
      projectionUpgradeModel: '',
      projectionUpgradeSelected: '',
      projectionWithProUpgradeModel: '',
      proUpgrade: '',
      proUpgradeFabrics: '',
      proUpgradeModel: '',
      rafterAdapterBrackets: '',
      series: '',
      size: '',
      sstDescription: '',
      sstDiscount: '',
      valanceStyle: '',
      variantCode: '',
      led: '',
    };
    this.modelData = {};
    this.na = 'N/A';
    this.sessionStorageKey = 'sst-awning-config';
    this.swatchesJs = null;
    this.init();
  }

  init() {
    document.addEventListener('click', (event) => {
      const optionAttr = 'data-awning-option';
      const optionValAttr = 'data-awning-option-value';
      const optionBtn = event.target.closest(`[${optionValAttr}]`);
      if (optionBtn) {
        const data = JSON.parse(optionBtn.getAttribute(optionValAttr));
        // Set active element, option
        const option = optionBtn.getAttribute(optionAttr);
        data.active = {
          element: optionBtn,
          option,
        };
        if (option === Constants.model) {
          this.resetProperty('price');
        }
        this.setState(data);
        this.render();
      }
    });
    // Add event handler for continue button
    const continueBtn = document.querySelector('.continue-btn');
    if (continueBtn) {
      continueBtn.addEventListener('click', (event) => {
        event.preventDefault();
        continueBtn.classList.add('updating');
        continueBtn.setAttribute('disabled', 'disabled');
        const state = this.getState();
        // Validate configuration
        if (!validate(state)) {
          continueBtn.classList.remove('updating');
          continueBtn.removeAttribute('disabled');
          return;
        }
        // If costco site

        // debugger;
        const { isCostco } = state;
        if (isCostco) {
          addAwningToSstParamList(state)
            .then(() => {
              // Will likely need to check if success true/false
              continueBtn.classList.remove('updating');
              continueBtn.removeAttribute('disabled');
              const href = event.target.getAttribute('href');
              window.location = href;
            });
          return;
        }
        // Look up the awning variant code based on the
        // model, fabric, and, width... then append the
        // other selection values to code
        getAwningItemNumber(state, (itemNumber, variantCode) => {
          if (itemNumber === '') {
            continueBtn.classList.remove('updating');
            continueBtn.removeAttribute('disabled');
            const { alert, saveSelectionsErrorMessage } = window;
            // Need to move to CMS...
            alert(saveSelectionsErrorMessage);
            return;
          }
          // Save item number to state
          this.setState({ itemNumber, variantCode });
          // Save state to session storage
          saveToSession(this.sessionStorageKey, JSON.stringify(state));
          // Add to cart
          // Get url from event.target and set location
          addToEpiCart(variantCode)
            .then(() => {
              addAwningToSstParamList(state)
                .then((data) => {
                  this.setState({
                    sstDescription: data.sstDescription,
                    sstDiscount: data.sstDiscount,
                    sstUnitDiscount: data.sstUnitDiscount,
                    sstUnitPrice: data.sstUnitPrice,
                  });
                  addAwningToGtmDataLayer(state);
                  continueBtn.classList.remove('updating');
                  continueBtn.removeAttribute('disabled');
                  console.log(data);
                  if (!data.success) {
                    const { alert, saveSelectionsErrorMessage } = window;
                    alert(saveSelectionsErrorMessage);
                    return;
                  }
                  const href = event.target.getAttribute('href');
                  window.location = href;
                });
            });
        });
      });
    }
    // Add data attributes to fabric buttons
    initializeFabricDataAttributes();
    // Deselect any inputs on page that have been checked previously
    resetInputs();
  }

  setState(data) {
    Object.keys(data).forEach((key1) => {
      if (typeof data[key1] !== 'object') {
        this.state[key1] = data[key1];
      } else {
        Object.keys(data[key1]).forEach((key2) => {
          this.state[key1][key2] = data[key1][key2];
        });
      }
    });
    console.log(this.getState());
  }

  getState() {
    return this.state;
  }

  resetStateForSeriesSelection() {
    this.setState({
      aluminumHood: '',
      aluminumHoodUpgrade: '',
      cordSide: '',
      fabric: '',
      fabricCode: '',
      fabricCollection: '',
      frameColor: '',
      hasFrameColorOpt: true,
      itemNumber: '',
      masonryKit: '',
      model: '',
      modelCode: '',
      mount: '',
      price: {},
      projection: '',
      projectionUpgrade1: '',
      projectionUpgrade2: '',
      projectionUpgradeModel: '',
      projectionUpgradeSelected: '',
      projectionWithProUpgradeModel: '',
      proUpgrade: '',
      proScreenColor: '',
      proUpgradeFabrics: '',
      proUpgradeModel: '',
      rafterAdapterBrackets: '',
      size: '',
      sstDescription: '',
      sstDiscount: '',
      valanceStyle: '',
      variantCode: '',
      led: '',
    });
  }

  resetStateForModelSelection() {
    this.setState({
      aluminumHood: '',
      aluminumHoodUpgrade: '',
      cordSide: '',
      fabric: '',
      fabricCode: '',
      fabricCollection: '',
      frameColor: '',
      hasFrameColorOpt: true,
      itemNumber: '',
      masonryKit: '',
      mount: '',
      projection: '',
      projectionUpgrade1: '',
      projectionUpgrade2: '',
      projectionUpgradeModel: '',
      projectionUpgradeSelected: '',
      projectionWithProUpgradeModel: '',
      proUpgrade: '',
      proUpgradeFabrics: '',
      proUpgradeModel: '',
      rafterAdapterBrackets: '',
      valanceStyle: '',
      variantCode: '',
      led: '',
    });
    // Fabric should be reset to first item
    resetStepSelections(Constants.frameColor);
    resetStepSelections(Constants.projection);
    resetStepSelections(Constants.valanceStyle);
    resetStepSelections(Constants.proUpgrade);
    resetStepSelections(Constants.proFsColor);
    resetStepSelections(Constants.pro);
    resetStepSelections(Constants.cordSide);
    resetStepSelections(Constants.mount);
    resetStepSelections(Constants.led);
    const state = this.getState();
    resetMountUI(state);
  }

  resetProperty(prop) {
    const state = this.getState();
    Object.keys(state).forEach((key1) => {
      if (key1 === prop) {
        this.state[key1] = {};
      } else if (typeof state[key1] === 'object') {
        Object.keys(state[key1]).forEach((key2) => {
          if (key2 === prop) {
            this.state[key1][key2] = {};
          }
        });
      }
    });
  }

  onModelDataReceived(data, scope) {
    let that = this;
    if (!that) {
      that = scope;
    }
    const {
      aluminumHoodUpgrade,
      cordSide,
      frameColor,
      mount,
      projection,
      projectionUpgrade1,
      projectionUpgrade2,
      projectionUpgradeModel,
      projectionWithProUpgradeModel,
      proUpgrade,
      proUpgradeFabrics,
    } = data;
    const state = that.getState();
    const { size, modelCode, fabricCollection } = state;
    // Set reference to model data in case additional reference needed,
    // ...i.e. for reseting hidden valance step
    that.modelData = data;
    // Toggle step availabilty
    Object.keys(data).forEach((key) => {
      toggleStepAvailability(key, data[key]);
      // Set state values to 'N/A' if step is hidden
      // and (critically) there are no options for
      // the product. Do not need to unset, since
      // reseting model will automatically reset
      // the state properties.
      if (isStepHidden(key) && data[key].length === 0) {
        that.setState(JSON.parse(`{ "${key}": "${that.na}" }`));
      }
    });
    // If only 1 option, set value in state
    // Default is "Cream"
    if (frameColor.length === 1) {
      that.setState({
        frameColor: 'Cream',
        hasFrameColorOpt: false,
      });
    }
    // Projection only has one option (not including upgrades)
    that.setState({ projection: projection[0] });
    if (projectionUpgrade1 !== null) {
      that.setState({ projectionUpgrade1 });
    }
    if (projectionUpgrade2 !== null) {
      that.setState({ projectionUpgrade2 });
    }
    if (aluminumHoodUpgrade !== null) {
      that.setState({ aluminumHoodUpgrade });
    }
    const validateProj1 = size >= projectionUpgrade1 && projectionUpgrade1 !== null;
    const validateProj2 = size >= projectionUpgrade2 && projectionUpgrade2 !== null;
    if (validateProj1 || validateProj2) {
      toggleStepByName(Constants.projection, 'show');
    }
    // Set projection upgrade model
    if (projectionUpgradeModel !== '') {
      that.setState({ projectionUpgradeModel });
    }
    // Set PRO XL upgrade model
    if (projectionWithProUpgradeModel !== '') {
      that.setState({ projectionWithProUpgradeModel });
    }
    // Set PRO upgrade model
    if (proUpgrade !== '') {
      that.setState({
        proUpgradeModel: proUpgrade,
        proUpgradeFabrics: proUpgradeFabrics.toString(),
      });
    }
    // If cordSide hidden and mount visible, show mount step title, else hide
    let status = 'hide';
    if (cordSide.length === 0 && mount.length !== 0) {
      status = 'show';
    }
    toggleStepTitleByName(Constants.mount, status);
    updateProjectionUpgradeOptions(state);
    // Update step numbers based on available steps
    updateAvailableStepNums();

    toggleStepByName(Constants.continue, 'show');

    toggleStepByName(Constants.proFsColor, 'hide');
    toggleStepByName(Constants.proUpgrade, 'hide');

    if (isProModel(modelCode)) {
      toggleStepByName(Constants.proFsColor, 'show');
    } else if (isProUpgradable(modelCode, fabricCollection)) {
      toggleStepByName(Constants.proUpgrade, 'show');
    }
  }

  render() {
    const state = this.getState();
    const {
      active,
      fabricCollection,
      price,
      model,
      modelCode,
      mount,
      proUpgradeFabrics,
      series,
    } = state;
    const {
      element,
      option,
    } = active;
    switch (option) {
      case 'series':
        this.resetStateForSeriesSelection();
        updateModelsBySeries(state, () => {
          updateSeriesWrapper(state);
          toggleStepByName(Constants.model, 'show');
          toggleStepByName(Constants.fabric, 'hide');
          toggleStepByName(Constants.frameColor, 'hide');
          toggleStepByName(Constants.projection, 'hide');
          toggleStepByName(Constants.valanceStyle, 'hide');
          toggleStepByName(Constants.cordSide, 'hide');
          toggleStepByName(Constants.mount, 'hide');
          toggleStepByName(Constants.proUpgrade, 'hide');
          toggleStepByName(Constants.proFsColor, 'hide');
          toggleStepByName(Constants.led, 'hide');
          toggleStepByName(Constants.continue, 'hide');
          if (model !== '') {
            // Reset selected model
            this.setState({ model });
            // Scroll to selected model
            hideAllModels();
            showModelByName(model);
            // Do we need to add a timeout here?...
            setTimeout(() => {
              scrollToSection(Constants.model, state);
            }, 200);
          }/*  else {
            showFirstModel();
          } */
          updateSeriesButtonLabels(active);
          updateSeriesHeading(series);
        });
        break;
      case Constants.model: {
        this.resetStateForModelSelection();
        updateModelButtonLabels(state);
        // Update state w/ collection name
        const defaultFabricCollection = getCollectionNameFromHash(Object.keys(price)[0]);
        this.setState({ fabricCollection: defaultFabricCollection });
        updateCollectionsBySeries(state);
        updateSelectedCollection(state);
        // Update active swatch in swatches.js
        const swatchesJs = this.getSwatchesJs();
        if (swatchesJs) {
          swatchesJs.setState({
            activeCollection: {
              element: getSelectedCollection(defaultFabricCollection),
              id: Object.keys(price)[0],
            },
          });
          swatchesJs.updateCollection();
        }
        toggleStepByName(Constants.model, 'show');
        toggleStepByName(Constants.fabric, 'show');
        // Set selected fabric/fabricCode to default swatch values
        const fabricOptions = getSelectedFabricOptions();
        if (fabricOptions) {
          this.setState(fabricOptions);
        }
        // Update visible steps based on ajax call
        getModelDataByCode(modelCode, this.onModelDataReceived, this);
        // Update price for soffit bracket mount based on size
        updateSoffitBracketPrice(state);
        // Update price for aluminum hood upgrade based on model, size
        updateAluminumHoodPrice(state);
        // Scroll to fabrics
        setTimeout(() => {
          scrollToSection(Constants.fabric, state);
        }, 200);
        break;
      }
      case Constants.fabric: {
        if (proUpgradeFabrics.indexOf(fabricCollection) === -1) {
          toggleStepByName(Constants.proUpgrade, 'hide');
          this.setState({ proUpgrade: 'No' });
        } else {
          toggleStepByName(Constants.proUpgrade, 'show');
        }

        // vb 202501
        if (fabricCollection === Constants.sunsetterLaminated) {
          toggleStepByName(Constants.proUpgrade, 'hide');
          this.setState({ proUpgrade: '' });
        } else if (isProUpgradable(modelCode, fabricCollection)) {
          toggleStepByName(Constants.proUpgrade, 'show');
          this.setState({ proUpgrade: 'yes' });
        }

        if (hasLed(modelCode)) { // vb 20250522 LED for all motorized models
          toggleStepByName(Constants.led, 'show');
          this.setState({ led: '' });
        } else {
          toggleStepByName(Constants.led, 'hide');
          this.setState({ led: '' });
        }

        if (isProModel(modelCode)) {
          toggleStepByName(Constants.proFsColor, 'show');
          this.setState({ proScreenColor: 'W' });
        }
        // --

        // Depending on collection selected, show/hide valance step and set default to "wave"
        const { valanceStyle } = this.modelData;
        const isValanceAvailable = valanceStyle.length > 0;
        if (fabricCollection === Constants.sunsetterLaminated && isValanceAvailable) {
          toggleStepByName(Constants.valanceStyle, 'hide');
          this.setState({ valanceStyle: Constants.waveValance });
        } else if (fabricCollection !== Constants.sunsetterLaminated && isValanceAvailable) {
          toggleStepByName(Constants.valanceStyle, 'show');
          this.setState({ valanceStyle: '' });
        }
        break;
      }
      case Constants.frameColor:
        updateFrameColorUI();
        break;
      case Constants.projection:
        updateProjectionUI();
        // If option w/ ancestor selector of .upgrade-available
        // set projectionUpgradeSelected to Yes, otherwise No
        if (element.closest('.upgrade-available')) {
          this.setState({ projectionUpgradeSelected: 'Yes' });
        } else {
          this.setState({ projectionUpgradeSelected: 'No' });
        }
        break;
      case Constants.mount:
        updateMountUI();
        // Set/unset 'N/A' values...
        if (mount === 'Wall Bracket') {
          this.setState({
            masonryKit: 'No',
            rafterAdapterBrackets: this.na,
          });
        } else if (mount === 'Soffit Bracket') {
          this.setState({
            masonryKit: this.na,
            rafterAdapterBrackets: 'No',
          });
        }
        updateAluminumHoodUI(state);
        break;
      default:
    }
    updateAvailableStepNums();
  }

  setActiveSeries(selectedSeries) {
    const series = getActiveSeriesBtn(selectedSeries);
    this.setState({
      active: {
        element: series,
        option: Constants.series,
      },
    });
  }

  getSwatchesJs() {
    return this.swatchesJs;
  }

  setSwatchesJs(swatchesJs) {
    this.swatchesJs = swatchesJs;
  }
}
window.AwningConfigurator = AwningConfigurator;
/* eslint-enable no-console */
